"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1203],{

/***/ 78516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Button_Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Button/Button.styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 6rem;\n  border-radius: ",
        "px;\n  outline: none;\n  border: none;\n  padding: 0.75rem 1rem;\n  cursor: pointer;\n  &.btn__primary {\n    background: ",
        ";\n    color: ",
        ";\n    font-size: ",
        "rem;\n    font-family: ",
        ";\n    font-weight: ",
        ";\n  }\n  &.btn__primary:hover {\n    background: ",
        ";\n    transition: background 0.5s ease-in-out;\n  }\n  &.btn__secondary {\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n    font-size: ",
        "rem;\n    font-family: ",
        ";\n    font-weight: ",
        ";\n  }\n  &.btn__secondary:hover {\n    background: ",
        ";\n    transition: background 0.5s ease-in-out;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ButtonComponent = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "ButtonComponent",
    componentId: "sc-7bbccc7b-0"
})(_templateObject(), function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.roundness) || 0;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.backgroundColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.color;
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.textFontSize) || 1;
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.fontFamily) || "Arial";
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.fontWeight) || "500";
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.backgroundHoverColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.backgroundColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.borderColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.borderColor;
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.textFontSize) || 1;
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.fontFamily) || "Arial";
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.fontWeight) || "500";
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.secondaryButton) === null || ref === void 0 ? void 0 : ref.borderColor;
}, function(props) {
    var ref;
    return props === null || props === void 0 ? void 0 : (ref = props.primaryButton) === null || ref === void 0 ? void 0 : ref.color;
});

// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/btnUtils.js
var btnUtils = __webpack_require__(93080);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Button/Button.js



var Button = function(props) {
    var ref, ref1, ref2;
    return (props === null || props === void 0 ? void 0 : (ref = props.btnData) === null || ref === void 0 ? void 0 : ref.btnText) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonComponent, {
        className: "btn__".concat(props === null || props === void 0 ? void 0 : (ref1 = props.btnData) === null || ref1 === void 0 ? void 0 : ref1.type),
        primaryButton: props === null || props === void 0 ? void 0 : props.primaryButton,
        secondaryButton: props === null || props === void 0 ? void 0 : props.secondaryButton,
        onClick: function() {
            var ref;
            (0,btnUtils/* btnActionHandler */.c)(props === null || props === void 0 ? void 0 : (ref = props.btnData) === null || ref === void 0 ? void 0 : ref.actions, props === null || props === void 0 ? void 0 : props.callback);
            (props === null || props === void 0 ? void 0 : props.handleClose) && (props === null || props === void 0 ? void 0 : props.handleClose());
        },
        children: props === null || props === void 0 ? void 0 : (ref2 = props.btnData) === null || ref2 === void 0 ? void 0 : ref2.btnText
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var Button_Button = (Button);


/***/ }),

/***/ 58252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Description = function(props) {
    var ref;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        onClick: function(e) {
            var ref, ref1, ref2;
            e.stopPropagation();
            props === null || props === void 0 ? void 0 : (ref = props.handleEditText) === null || ref === void 0 ? void 0 : ref.call(props);
            props === null || props === void 0 ? void 0 : (ref2 = props.getInputPreFilledValue) === null || ref2 === void 0 ? void 0 : ref2.call(props, (ref1 = props.descriptionData) === null || ref1 === void 0 ? void 0 : ref1.text);
        },
        className: "Description",
        children: (ref = props.descriptionData) === null || ref === void 0 ? void 0 : ref.text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Description);


/***/ }),

/***/ 92578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Heading = function(props) {
    var ref;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        className: "Heading",
        children: props === null || props === void 0 ? void 0 : (ref = props.headingData) === null || ref === void 0 ? void 0 : ref.text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Heading);


/***/ }),

/***/ 81203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ModernHeroBanner6_ModernHeroBanner6; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Heading/Heading.js
var Heading = __webpack_require__(92578);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Description/Description.js
var Description = __webpack_require__(58252);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Button/Button.js + 1 modules
var Button = __webpack_require__(78516);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/common.ts
var common = __webpack_require__(37179);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/getStylesConfig.js
var getStylesConfig = __webpack_require__(42757);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/common.js + 9 modules
var utils_common = __webpack_require__(20901);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/HeroBanner/ModernHeroBanner6/ModernHeroBanner6.styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  background-size: cover;\n  background-position: center;\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 0; /* Set the z-index behind other content */\n  }\n\n  /* Add a linear gradient overlay */\n  &::after {\n    content: '';\n    background: ",
        ";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: ",
        ";\n    z-index: 1;\n  }\n  @media screen and (min-width: 768px) {\n    & > video {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover; /* Scale the video while maintaining its aspect ratio */\n    }\n  }\n  @media screen and (max-width: 767px) {\n    & > video {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover; /* Scale the video while maintaining its aspect ratio */\n    }\n  }\n  & > video {\n    position: absolute;\n    height: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.bg_type_image {\n    background: ",
        ";\n    background-size: cover;\n    background-position: center;\n    & > .bg {\n      position: absolute;\n      height: 100%;\n      object-fit: fill;\n      width: 100%;\n    }\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      z-index: 0; /* Set the z-index behind other content */\n    }\n    /* Add a linear gradient overlay */\n    &::after {\n      content: '';\n      background: ",
        ";\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      opacity: ",
        ";\n      z-index: 1;\n    }\n  }\n\n  &.bg_type_solid {\n    background: ",
        ";\n  }\n  &.bg_type_image::after,\n  .bg_type_solid {\n    content: '';\n    background: ",
        ";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: ",
        ";\n    z-index: 1;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  @media screen and (min-width: 768px) {\n    gap: 0;\n  }\n  @media screen and (max-width: 767px) {\n    gap: 2rem;\n    padding-bottom: 2rem;\n    padding-top: 1.106rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 1rem;\n  width: 100%;\n  overflow-x: auto;\n  z-index: 99;\n  .child_container img {\n    width: 100%;\n    background-color: ",
        ";\n  }\n  @media screen and (min-width: 768px) {\n    padding: 4.75rem 1rem 0 1rem;\n    flex-wrap: wrap;\n    & > .child_container {\n      flex: 0 0 calc((100% - 2rem) / 3);\n    }\n  }\n  @media screen and (max-width: 767px) {\n    padding: 0.894rem 0 1rem 1rem;\n    flex-wrap: nowrap;\n    & > .child_container {\n      flex: 0 0 calc((100% - 2rem) / 1);\n    }\n  }\n\n  &::-webkit-scrollbar {\n    width: 0.2rem; /* Set the scrollbar width to a small value */\n    height: 0.2rem; /* Set the scrollbar height to a small value */\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: transparent; /* Make the scrollbar thumb transparent */\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent; /* Make the scrollbar track transparent */\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  z-index: 99;\n  @media screen and (min-width: 768px) {\n    padding: 4.75rem 8.25rem;\n    gap: 2.625rem;\n  }\n  @media screen and (max-width: 767px) {\n    padding: 0 1.5rem;\n    gap: 1.5rem;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 1.5rem;\n  align-self: center;\n  & > h1 {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    color: ",
        ";\n    font-family: ",
        ";\n    text-align: ",
        ";\n    margin: 0;\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  & > p {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    font-style: normal;\n    margin: 0;\n    color: ",
        ";\n    text-align: ",
        ";\n    font-family: ",
        ";\n    opacity: ",
        ";\n    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */\n    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */\n  }\n  @media screen and (min-width: 768px) {\n    gap: 1.5rem;\n    & > h1 {\n      font-size: ",
        ";\n      font-weight: ",
        ";\n      line-height: 4.5rem;\n      justify-content: center;\n    }\n    & > p {\n      font-size: ",
        ";\n      font-weight: ",
        ";\n      line-height: normal;\n      justify-content: center;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    gap: 0.75rem;\n    & > h1 {\n      font-size: 2rem;\n      font-weight: 600;\n      line-height: normal;\n      justify-content: left;\n    }\n    & > p {\n      font-size: 0.875rem;\n      font-weight: 400;\n      line-height: normal;\n      justify-content: left;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  flex-wrap: wrap;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  @media screen and (min-width: 768px) {\n    justify-content: flex-start;\n  }\n  @media screen and (max-width: 767px) {\n    justify-content: center;\n    flex-direction: column;\n    width: 100%;\n    button {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var HeroBannerVideoBackground = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeroBannerVideoBackground",
    componentId: "sc-1381f5a4-0"
})(_templateObject(), function(props) {
    var ref, ref1;
    return !((ref1 = props === null || props === void 0 ? void 0 : (ref = props.propsBackground) === null || ref === void 0 ? void 0 : ref.content[0]) === null || ref1 === void 0 ? void 0 : ref1.url) && "none, ".concat(props === null || props === void 0 ? void 0 : props.themeBackground);
}, function(props) {
    return props === null || props === void 0 ? void 0 : props.themeBackground;
}, utils_common/* BANNER_OPACITY */.Gx);
var HeroBannerParent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeroBannerParent",
    componentId: "sc-1381f5a4-1"
})(_templateObject1(), function(props) {
    var ref, ref1, ref2, ref3;
    return ((ref1 = props === null || props === void 0 ? void 0 : (ref = props.propsBackground) === null || ref === void 0 ? void 0 : ref.content[0]) === null || ref1 === void 0 ? void 0 : ref1.url) ? "url(".concat((ref3 = props === null || props === void 0 ? void 0 : (ref2 = props.propsBackground) === null || ref2 === void 0 ? void 0 : ref2.content[0]) === null || ref3 === void 0 ? void 0 : ref3.url, ")") : "none, ".concat(props === null || props === void 0 ? void 0 : props.themeBackground);
}, function(props) {
    return props === null || props === void 0 ? void 0 : props.themeBackground;
}, utils_common/* BANNER_OPACITY */.Gx, function(props) {
    return props === null || props === void 0 ? void 0 : props.themeBackground;
}, function(props) {
    return props === null || props === void 0 ? void 0 : props.themeBackground;
}, utils_common/* BANNER_OPACITY */.Gx);
var BannerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BannerContainer",
    componentId: "sc-1381f5a4-2"
})(_templateObject2());
var TopBannerSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TopBannerSection",
    componentId: "sc-1381f5a4-3"
})(_templateObject3(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.IS_MEDIA_URL) ? "transparent" : utils_common/* FALLBACK_COLOR */.R3;
});
var BottomBannerSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BottomBannerSection",
    componentId: "sc-1381f5a4-4"
})(_templateObject4());
var TopSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TopSection",
    componentId: "sc-1381f5a4-5"
})(_templateObject5(), function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "center";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "center";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, utils_common/* BODY_COLOR_OPACITY */.ur, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "3.875rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "500";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "1.25rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "400";
});
var BottomSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BottomSection",
    componentId: "sc-1381f5a4-6"
})(_templateObject6());
var ButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ButtonContainer",
    componentId: "sc-1381f5a4-7"
})(_templateObject7());

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var actions_common = __webpack_require__(31024);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/HeroBanner/ModernHeroBanner6/ModernHeroBanner6.js


// import EditText from '../../CommonComponents/EditText/EditText'










function ModernHeroBanner6(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var widgetData = (0,es/* useSelector */.v9)(function(state) {
        return {
            widgetData: state.widgetsReducer
        };
    }).widgetData;
    var ref26 = (0,react.useState)((0,common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.children)), heroBannerState = ref26[0], setHeroBannerState = ref26[1];
    var ref27 = (0,react.useState)({
        config: {
            bannerAspectRatio: {
                desktop: 768,
                mobile: 768
            },
            rotationSpeed: 3
        }
    }), styleConfig = ref27[0];
    var dispatch = (0,es/* useDispatch */.I0)();
    var openForm = function() {
        dispatch((0,actions_common/* toggleFormWidget */.Aq)(true));
    };
    (0,react.useEffect)(function() {
        var ref;
        if (props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.children) {
            var ref1;
            setHeroBannerState((0,common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref1 = props.config) === null || ref1 === void 0 ? void 0 : ref1.children));
        }
    }, [
        props === null || props === void 0 ? void 0 : (ref1 = props.config) === null || ref1 === void 0 ? void 0 : ref1.children
    ]);
    (0,react.useEffect)(function() {
        var video = document.querySelector("video");
        if (video) {
            video.setAttribute("playsinline", "");
        }
    }, []);
    var ref28 = (0,react.useState)(storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : ref2.style_template), propStyle = ref28[0], setPropStyle = ref28[1];
    (0,react.useEffect)(function() {
        if (widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate) {
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate));
        } else {
            var ref;
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.style_template));
        }
    }, [
        widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate,
        storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.theme) === null || ref3 === void 0 ? void 0 : ref3.style_template
    ]);
    var renderParentContainer = function(bgType) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                (heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref = heroBannerState.media) === null || ref === void 0 ? void 0 : (ref1 = ref.foreground) === null || ref1 === void 0 ? void 0 : ref1.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBannerSection, {
                    IS_MEDIA_URL: (heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref2 = heroBannerState.media) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.foreground) === null || ref3 === void 0 ? void 0 : ref3.content.length) > 0 ? true : false,
                    children: heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref4 = heroBannerState.media) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.foreground) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.content) === null || ref6 === void 0 ? void 0 : ref6.map(function(param, idx) {
                        var url = param.url;
                        var ref, ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                            className: "child_container",
                            children: (0,utils_common/* renderMediaComponent */.CB)({
                                type: heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref = heroBannerState.media) === null || ref === void 0 ? void 0 : (ref1 = ref.foreground) === null || ref1 === void 0 ? void 0 : ref1.type,
                                content: [
                                    {
                                        url: url
                                    }
                                ]
                            }, "grid")
                        }, idx);
                    })
                }),
                ((heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref7 = heroBannerState.heading) === null || ref7 === void 0 ? void 0 : ref7.text) || (heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref8 = heroBannerState.description) === null || ref8 === void 0 ? void 0 : ref8.text) || (heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref9 = heroBannerState.button) === null || ref9 === void 0 ? void 0 : ref9.content)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomBannerSection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopSection, {
                            textStyles: propStyle,
                            children: [
                                (heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref10 = heroBannerState.heading) === null || ref10 === void 0 ? void 0 : ref10.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    headingData: heroBannerState === null || heroBannerState === void 0 ? void 0 : heroBannerState.heading
                                }),
                                (heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref11 = heroBannerState.description) === null || ref11 === void 0 ? void 0 : ref11.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                                    descriptionData: heroBannerState === null || heroBannerState === void 0 ? void 0 : heroBannerState.description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSection, {
                            children: (heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref12 = heroBannerState.button) === null || ref12 === void 0 ? void 0 : ref12.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonContainer, {
                                children: heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref13 = heroBannerState.button) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.content) === null || ref14 === void 0 ? void 0 : ref14.map(function(btnData, idx) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        btnData: btnData,
                                        primaryButton: propStyle === null || propStyle === void 0 ? void 0 : propStyle.buttonPrimary,
                                        secondaryButton: propStyle === null || propStyle === void 0 ? void 0 : propStyle.buttonSecondary,
                                        callback: openForm
                                    }, (btnData === null || btnData === void 0 ? void 0 : btnData.id) || idx);
                                })
                            })
                        })
                    ]
                })
            ]
        });
    };
    return (heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref4 = heroBannerState.media) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.background) === null || ref5 === void 0 ? void 0 : ref5.type) === "video" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroBannerVideoBackground, {
        id: "MT__HEROBANNER6",
        background: heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref6 = heroBannerState.media) === null || ref6 === void 0 ? void 0 : ref6.background,
        styleConfig: styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.config,
        themeBackground: propStyle === null || propStyle === void 0 ? void 0 : propStyle.backgroundColor,
        className: "modern_theme_hero_banner6 bg_type_".concat(heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref7 = heroBannerState.media) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.background) === null || ref8 === void 0 ? void 0 : ref8.type),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                autoPlay: true,
                loop: true,
                muted: true,
                onError: function(e) {
                    var ref, ref1, ref2;
                    return e.target.src = (ref2 = heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref = heroBannerState.media) === null || ref === void 0 ? void 0 : (ref1 = ref.background) === null || ref1 === void 0 ? void 0 : ref1.content[0]) === null || ref2 === void 0 ? void 0 : ref2.url;
                },
                playsInline: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: (ref11 = heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref9 = heroBannerState.media) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.background) === null || ref10 === void 0 ? void 0 : ref10.content[0]) === null || ref11 === void 0 ? void 0 : ref11.url,
                    type: "video/mp4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBannerParent, {
                id: "MT__HEROBANNER6",
                styleConfig: styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.config,
                propsBackground: heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref12 = heroBannerState.media) === null || ref12 === void 0 ? void 0 : ref12.background,
                themeBackground: propStyle === null || propStyle === void 0 ? void 0 : propStyle.backgroundColor,
                className: "modern_theme_hero_banner6 bg_type_".concat(heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref13 = heroBannerState.media) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.background) === null || ref14 === void 0 ? void 0 : ref14.type),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerContainer, {
                    children: renderParentContainer("video")
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroBannerParent, {
        id: "MT__HEROBANNER6",
        styleConfig: styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.config,
        propsBackground: heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref15 = heroBannerState.media) === null || ref15 === void 0 ? void 0 : ref15.background,
        themeBackground: propStyle === null || propStyle === void 0 ? void 0 : propStyle.backgroundColor,
        className: "modern_theme_hero_banner6 bg_type_".concat(heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref16 = heroBannerState.media) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.background) === null || ref17 === void 0 ? void 0 : ref17.type),
        children: [
            (heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref18 = heroBannerState.media) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.background) === null || ref19 === void 0 ? void 0 : ref19.type) === "image" && ((ref22 = heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref20 = heroBannerState.media) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.background) === null || ref21 === void 0 ? void 0 : ref21.content[0]) === null || ref22 === void 0 ? void 0 : ref22.url.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: "bg",
                src: (ref25 = heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref23 = heroBannerState.media) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.background) === null || ref24 === void 0 ? void 0 : ref24.content[0]) === null || ref25 === void 0 ? void 0 : ref25.url,
                onError: function(e) {
                    var ref, ref1, ref2;
                    return e.target.src = (ref2 = heroBannerState === null || heroBannerState === void 0 ? void 0 : (ref = heroBannerState.media) === null || ref === void 0 ? void 0 : (ref1 = ref.background) === null || ref1 === void 0 ? void 0 : ref1.content[0]) === null || ref2 === void 0 ? void 0 : ref2.url;
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerContainer, {
                children: renderParentContainer("image")
            })
        ]
    });
}
/* harmony default export */ var ModernHeroBanner6_ModernHeroBanner6 = (ModernHeroBanner6);


/***/ })

}]);